"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const eo_1 = __importDefault(require("date-fns/locale/eo")); //
const dateEo = {
    name: 'eo',
    locale: eo_1.default
};
exports.default = dateEo;
